import { render, staticRenderFns } from "./EditUserPage.vue?vue&type=template&id=05eb964d&scoped=true&"
import script from "./EditUserPage.vue?vue&type=script&lang=js&"
export * from "./EditUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb964d",
  null
  
)

export default component.exports